export default "__VITE_ASSET__irJbmYZH__"